module.exports = __webpack_public_path__ + "img/team-1.66f62826.jpg";